module.exports = __webpack_public_path__ + "img/loading.1d7626e6.gif";